import { makeStyles } from '@material-ui/core/styles';
import { layerFont } from 'constants/defaultItems';

export default makeStyles((theme) => ({
  pathBackground: {
    backgroundColor: ({ borderColor }) => borderColor,
    position: 'absolute',
    borderRadius: 6,
    height: '100%',
    width: '100%',
    '&::after': {
      width: 'calc(100% - 2px)',
      height: 'calc(100% - 4px)',
      backgroundColor: ({ backgroundColor }) => backgroundColor,
      position: 'absolute',
      borderRadius: 6,
      content: '""',
      left: 1,
      top: ({ vertical }) => (vertical === 'top' ? 3.5 : 2),
      clipPath: ({ fCoords }) =>
        `polygon(${fCoords
          .map((coords) => `${coords.x}% ${coords.y - 1}%`)
          .join(', ')})`,
    },
  },
  formHandlesBlock: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: 10,
    '& > *': {
      backgroundColor: 'fuchsia',
      position: 'absolute',
      borderRadius: '50%',
      cursor: 'grab',
      height: 10,
      zIndex: 10,
      width: 10,
    },
  },
  layerText: {
    fontFamily: ({ textStyle }) =>
      `${textStyle.fontStyle}` || layerFont.fontStyle,
    fontSize: ({ textStyle }) =>
      `${textStyle.fontSize}pt` || layerFont.fontSize,
    color: theme.colors.black,
    wordBreak: 'break-all',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    width: '100%',
    margin: 0,
  },
  speechTextContainer: {
    bottom: ({ vertical }) => vertical === 'top' && 0,
    height: ({ speechControls, vertical, fCoords }) =>
      `${
        vertical === 'top'
          ? 100 - fCoords[speechControls[0]]?.y
          : fCoords[speechControls[0]]?.y
      }%`,
    position: 'absolute',
    width: '100%',
    padding: 7,
  },
  speechBubbleText: {
    transform: 'translate(0, -50%)',
    pointerEvents: 'none',
    position: 'absolute',
    textAlign: 'left',
    top: '50%',
    zIndex: 2,
  },
}));
